import { CustomSelector } from "../ui/components/CustomSelector";
import { Offcanvas } from "bootstrap";

export class DownloadChoice extends CustomSelector {
    #onChange = () => { };
    #selectedTabId = null;

    init() {
        super.init();

    }

    handleOptionSelect(e, option) {
        e.stopPropagation();

        const tabId = option.getAttribute("data-tab-id");
        const text = option.textContent.trim();

        this.setSelectedTab(tabId, text);
        this.closeOptions();

        if (tabId != null) this.#onChange(String(tabId));
    }

    handleMobileOptionSelect(e, option) {
        e.stopPropagation();
        const tabId = option.getAttribute("data-tab-id");
        const text = option.textContent.trim();

        this.setSelectedTab(tabId, text);

        if (tabId != null) this.#onChange(String(tabId));
    }

    setSelectedTab(tabId, text = null) {
        if (tabId == null) return;
        const idStr = String(tabId);
        this.#selectedTabId = idStr;

        if (!text) {
            const options = Array.from(this.getSelectOptions?.() || []);
            const opt = options.find(
                (el) => el?.getAttribute?.("data-tab-id") === idStr
            );
            text = opt?.textContent?.trim() || "";
        }

        if (this.selectedText?.element) {
            this.selectedText.element.textContent = text;
        }

        const all = Array.from(this.getSelectOptions?.() || []);
        all.forEach((el) => el?.classList?.remove("active"));
        all.forEach((el) => {
            if (el.getAttribute?.("data-tab-id") === idStr) {
                el.classList.add("active");
            }
        });
    }

    getSelectedTabId() {
        return this.#selectedTabId;
    }

    addOption({ tabId, title }) {
        if (tabId == null) return;
        const idStr = String(tabId);
        const text = String(title ?? "").trim();
        if (!text) return;

        const existing = Array.from(this.getSelectOptions?.() || []).some(
            (el) => el?.getAttribute?.("data-tab-id") === idStr
        );
        if (existing) return;

        this.show?.();

        const optionsContainer =
            this.selectOptions?.el?.() ||
            this.selectOptions?.element ||
            this.selectOptions;
        if (optionsContainer instanceof HTMLElement) {
            const opt = document.createElement("div");
            opt.className =
                "language-choice__custom-select__select-option download-element px-3 py-2 r";
            opt.id = "selectOption";
            opt.setAttribute("data-tab-id", idStr);
            opt.innerHTML = `<span>${text}</span>`;
            opt.addEventListener("click", (e) => this.handleOptionSelect(e, opt));
            optionsContainer.appendChild(opt);
        }

        const offcanvasTarget =
            this.selectSelected?.element?.getAttribute?.("data-bs-target") || null;
        const offcanvasEl =
            (offcanvasTarget && this.element.querySelector(offcanvasTarget)) ||
            this.element.querySelector(".offcanvas");
        const offcanvasBody = offcanvasEl?.querySelector?.(".offcanvas-body");
        if (offcanvasBody) {
            const opt = document.createElement("div");
            opt.className =
                "language-choice__custom-select__select-option download-element";
            opt.id = "selectOption";
            opt.setAttribute("data-tab-id", idStr);
            opt.innerHTML = `<span style="color:#0B0F19; font-size:14px; font-weight: 400;">${
                text
            }</span>`;
            opt.addEventListener("click", (e) => {
                this.handleMobileOptionSelect(e, opt);
                const inst =
                    Offcanvas.getInstance(offcanvasEl) || new Offcanvas(offcanvasEl);
                inst.hide();
            });
            offcanvasBody.appendChild(opt);
        }
    }

    removeOption(tabId) {
        if (tabId == null) return;
        const idStr = String(tabId);
        if (idStr === "0") return; 

        const options = Array.from(this.getSelectOptions?.() || []);
        options.forEach((el) => {
            if (el?.getAttribute?.("data-tab-id") === idStr) el.remove();
        });

        const offcanvasEl = this.#getOffcanvasEl();
        const offcanvasBody = offcanvasEl?.querySelector?.(".offcanvas-body");
        if (offcanvasBody) {
            Array.from(offcanvasBody.querySelectorAll?.('[data-tab-id]') || []).forEach((el) => {
                if (el?.getAttribute?.("data-tab-id") === idStr) el.remove();
            });
        }
        if (this.#selectedTabId === idStr) {
            this.setSelectedTab("0");
        }

        const remaining = Array.from(this.getSelectOptions?.() || []).some(
            (el) => el?.getAttribute?.("data-tab-id") && el.getAttribute("data-tab-id") !== "0"
        );
        if (!remaining) {
            this.hide?.();
        }
    }

    #getOffcanvasEl() {
        const offcanvasTarget =
            this.selectSelected?.element?.getAttribute?.("data-bs-target") || null;
        return (
            (offcanvasTarget && document.querySelector(offcanvasTarget)) ||
            this.element.querySelector(".offcanvas") ||
            null
        );
    }


    onChange(cb) {
        if (typeof cb !== "function") return;
        this.#onChange = cb;
    }

}
